import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SessionIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 1.25C6.0723 1.25 1.25 6.0723 1.25 12C1.25 12.3618 1.2676 12.7197 1.3027 13.0732C1.3408 13.4599 1.667 13.749 2.0478 13.749C2.0727 13.749 2.0976 13.748 2.123 13.7451C2.5351 13.7041 2.8359 13.3369 2.7949 12.9248C2.7646 12.6201 2.75 12.312 2.75 12C2.75 6.8994 6.8994 2.75 12 2.75C17.1006 2.75 21.25 6.8994 21.25 12C21.25 17.1006 17.1006 21.25 12 21.25C11.688 21.25 11.3784 21.2344 11.0742 21.2051C10.6601 21.1533 10.2949 21.4658 10.2544 21.878C10.2139 22.2902 10.5156 22.6573 10.9277 22.6973C11.2798 22.7325 11.6381 22.75 12 22.75C17.9277 22.75 22.75 17.9277 22.75 12C22.75 6.0723 17.9277 1.25 12 1.25Z"
        fill={color}
      />
      <path
        d="M12 4.375C11.6548 4.375 11.375 4.6548 11.375 5V12C11.375 12.2231 11.4941 12.4297 11.6875 12.5415L15.1514 14.541C15.4453 14.7122 15.8322 14.6138 16.0049 14.3125C16.1778 14.0137 16.0752 13.6309 15.7764 13.459L12.625 11.6392V5C12.625 4.6548 12.3452 4.375 12 4.375Z"
        fill={color}
      />
      <path
        d="M3.64026 15.9629C3.46256 15.5889 3.01426 15.4307 2.64126 15.6065C2.26676 15.7842 2.10756 16.2315 2.28486 16.6055C2.54706 17.1582 2.85906 17.6924 3.21306 18.1934C3.45346 18.5343 3.92396 18.6105 4.25846 18.3731C4.59686 18.1348 4.67736 17.667 4.43866 17.3282C4.13396 16.8966 3.86536 16.4375 3.64026 15.9629Z"
        fill={color}
      />
      <path
        d="M8.03364 20.3584C7.56004 20.1338 7.10104 19.8652 6.66844 19.5596C6.33154 19.3213 5.86224 19.3994 5.62354 19.7393C5.38424 20.0772 5.46484 20.545 5.80324 20.7842C6.30524 21.1397 6.83934 21.4522 7.39014 21.7139C7.75574 21.889 8.21124 21.7358 8.38914 21.3584C8.56684 20.9834 8.40774 20.5361 8.03364 20.3584Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SessionIcon.displayName = 'SessionIcon';
